export default __webpack_public_path__ + "static/alfred_quitall-77f2aff646ee42b2bdfffa3e8933d03d.png";